import {ObjectListHelper} from './object-list.helper';
import {ISimpleSelectableData, ISimpleSelectableDataList} from '../model/interface/simple-selectable-data.model.interface';
import {IAddressType, IAddressTypeList} from '../model/interface/address-type.model.interface';

export class AddressTypeHelper {
  static toSelectableList(list: IAddressTypeList): ISimpleSelectableDataList {
    const array = list.data
      .map(entity => AddressTypeHelper.itemToSelectableItem(entity));
    return ObjectListHelper.fromArray(array);
  }

  private static itemToSelectableItem(item: IAddressType): ISimpleSelectableData {
    return {
      label: item.label,
      value: item.id
    };
  }

}
